// export const ACTION_FETCH_USER_LOGIN = 'ACTION_FETCH_USER_LOGIN';
// export const ACTION_DO_LOGOUT = 'ACTION_DO_LOGOUT';
//
// export const COMMIT_SET_USER_LOGIN = 'COMMIT_SET_USER_LOGIN';
//
// export const MUTATION_DO_LOGOUT = 'MUTATION_DO_LOGOUT';
//
// export const GETTER_IS_LOGGEDIN = 'GETTER_IS_LOGGEDIN';

export const GETTERS_REPORT_CATEGORIES_LIST = "GETTERS_REPORT_CATEGORIES_LIST";
export const GETTERS_FULL_REPORT_CATEGORIES_LIST =
  "GETTERS_FULL_REPORT_CATEGORIES_LIST";

// action
export const ACTION_GET_REPORT_CATEGORIES_LIST =
  "ACTION_GET_REPORT_CATEGORIES_LIST";
export const ACTION_GET_ALL_REPORT_CATEGORIES =
  "ACTION_GET_ALL_REPORT_CATEGORIES";
// export const ACTION_DELETE_EMPLOYER = 'ACTION_DELETE_EMPLOYER';
// export const ACTION_ADD_EMPLOYER = 'ACTION_ADD_EMPLOYER';
// export const ACTION_EDIT_EMPLOYER = 'ACTION_EDIT_EMPLOYER';
// export const ACTION_GET_EMPLOYER = 'ACTION_GET_EMPLOYER';
// export const ACTION_SET_EMPTY_EMPLOYER = 'ACTION_SET_EMPTY_EMPLOYER';

export const MUTATION_SET_REPORT_CATEGORIES_LIST =
  "MUTATION_SET_REPORT_CATEGORIES_LIST";
export const MUTATION_SET_ALL_REPORT_CATEGORIES =
  "MUTATION_GET_ALL_REPORT_CATEGORIES";



// WEBPACK FOOTER //
// ./src/store/modules/report_categories/constants.js